/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-globals */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { cadastramentoData } from "store/actions/cadastramentoActions";
import i18n from "i18next";
import { ResponsiveBar } from "@nivo/bar";
import {
  ConvertToNumber,
  formatNumber,
  isEmptyObj,
  isObj,
  renderLegendNivo,
} from "helpers/utils";
import { useReportStore } from "service/report.service";

function Cadastramento() {
  const dispatch = useDispatch();
  const choice = useSelector((state) => state.choice);
  const { cadastramentoInner } = useSelector((state) => state.cadastramento);
  const [data, setData] = useState([]);
  const [dataLengend, setDataLegend] = useState([]);
  const customColors = ["#A66C29", "#F0B70E", "#808080"];
  const { type } = choice || {};
  const { sizeFilter } = useReportStore();

  useEffect(() => {
    dispatch(cadastramentoData(choice));
  }, [dispatch, choice]);

  const validEmptyLand =
    cadastramentoInner?.empty_land && !isNaN(cadastramentoInner?.empty_land);

  useEffect(() => {
    if (isObj(cadastramentoInner) && !isEmptyObj(cadastramentoInner)) {
      const dataObj = [
        {
          [i18n.t("nonRegisteredArea")]: Number(
            cadastramentoInner.not_registered
          ),
          [i18n.t("registeredArea")]: Number(
            cadastramentoInner.registered_area
          ),
          size: "",
        },
      ];

      const legendArray = [
        {
          name: i18n.t("registeredArea"),
          value: ConvertToNumber(cadastramentoInner.registered_area),
          totalVal: ConvertToNumber(cadastramentoInner.registration_area),
          color: "#F0B70E",
          isPattern: false,
        },
        {
          name: i18n.t("nonRegisteredArea"),
          value: ConvertToNumber(cadastramentoInner.not_registered),
          totalVal: ConvertToNumber(cadastramentoInner.registration_area),
          color: "#A66C29",
          isPattern: false,
        },
      ];

      setData(dataObj);
      setDataLegend(legendArray);
    }
  }, [cadastramentoInner]);

  const conditionalArray = validEmptyLand
    ? [
        i18n.t("nonRegisteredArea"),
        i18n.t("registeredArea"),
        // i18n.t("emptyLand"),
      ]
    : [i18n.t("nonRegisteredArea"), i18n.t("registeredArea")];

  const customLegends = dataLengend.map((d) =>
    renderLegendNivo({
      type: d.name,
      value: d.value,
      total: d.totalVal,
      color: d.color,
    })
  );

  return (
    <div className="tcf-map-report--body-territorialcut-item--body--bar">
      {data && (
        <ResponsiveBar
          data={data}
          keys={conditionalArray}
          indexBy="size"
          margin={{ top: 0, right: 240, bottom: 45, left: 120 }}
          padding={0.6}
          valueScale={{ type: "linear" }}
          indexScale={{ type: "band", round: true }}
          valueFormat=">-,~"
          colors={customColors}
          borderColor={{
            from: "color",
            modifiers: [["darker", 1.6]],
          }}
          axisTop={null}
          axisRight={null}
          axisBottom={
            type === "rural_properties"
              ? {
                  tickSize: 5,
                  tickPadding: 5,
                  tickRotation: 0,
                  legend: "",
                  legendPosition: "middle",
                  legendOffset: 32,
                  truncateTickAt: 0,
                }
              : false
          }
          axisLeft={{
            tickSize: 0,
            tickPadding: 15,
            tickRotation: 0,
            legend: i18n.t("areaHa"),
            legendPosition: "middle",
            legendOffset: -100,
            truncateTickAt: 0,
          }}
          enableLabel={false}
          legends={[
            {
              dataFrom: "keys",
              anchor: "right",
              direction: "column",
              justify: false,
              translateX: 140,
              translateY: 0,
              itemsSpacing: 20,
              itemWidth: 100,
              itemHeight: 20,
              itemDirection: "left-to-right",
              itemOpacity: 0.85,
              symbolSize: 20,
              effects: [
                {
                  on: "hover",
                  style: {
                    itemOpacity: 1,
                  },
                },
              ],
              data: customLegends,
            },
          ]}
          tooltip={({ id, value }) => (
            <div className="tcf-custom-bar-tooltip">
              <strong>{id} : </strong>
              {formatNumber(value, 0, ".", ",")} ha
            </div>
          )}
          role="application"
          ariaLabel="Nivo bar chart demo"
          barAriaLabel={(e) =>
            e.id + ": " + e.formattedValue + " in country: " + e.indexValue
          }
        />
      )}
    </div>
  );
}

export default Cadastramento;
